'use client';

import { useState } from 'react';
import Link from 'next/link';
import { 
  ShieldCheck, ArrowRight, Menu, Phone, Mail, Linkedin, Instagram, Youtube,
  Brain, Megaphone, ClipboardCheck, Target, Shirt, HelpCircle, Users,
  CheckCircle2, Check, Clock, User, BarChart2, Server, Cloud, LockKeyhole, Cpu, X, ChevronRight
} from 'lucide-react';

export default function RecursosPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const wppLink = "https://wa.me/554888796761?text=Quero%20falar%20com%20um%20especialista%20sobre%20o%20sistema%20Nexus%20Safe.";
  const appLink = "https://app.nexussafe.com.br/";

  return (
    <div className="min-h-screen bg-white selection:bg-blue-200 selection:text-blue-900 font-sans text-gray-800 relative flex flex-col overflow-x-hidden">
      
      {/* ================= FIO LATERAL COLORIDO ================= */}
      <div className="hidden sm:block" style={{
        position: 'fixed', top: 0, left: '24px', width: '6px', height: '100vh',
        background: 'linear-gradient(to bottom, #06b6d4, #3b82f6, #8b5cf6, #ec4899)', 
        zIndex: 99999, boxShadow: '0 0 15px rgba(59, 130, 246, 0.4)'
      }}></div>

      {/* ================= NAVBAR ================= */}
      <nav className="fixed w-full bg-white/95 backdrop-blur-md z-50 border-b border-gray-100 shadow-sm top-0">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between relative">
          <div className="flex items-center shrink-0 h-full">
            <Link href="/" className="flex items-center">
              <img src="/logo-nexus.png" alt="NexusSafe" style={{ height: '40px', width: 'auto' }}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if(fallback) fallback.style.display = 'flex';
                }}
              />
              <div style={{ display: 'none' }} className="items-center gap-2">
                <ShieldCheck size={28} className="text-gray-900" />
                <span className="text-xl font-black text-gray-900 tracking-tight">NEXUS<span className="font-light">SAFE</span></span>
              </div>
            </Link>
          </div>
          
          <div className="hidden md:flex items-center gap-4 lg:gap-8 font-bold text-sm text-gray-600">
            <Link href="/site/solucoes" className="hover:text-blue-600 transition-colors">Soluções</Link>
            <Link href="/site/para-quem-e" className="hover:text-blue-600 transition-colors">Para quem é</Link>
            <Link href="/site/recursos" className="text-blue-600 transition-colors">Recursos</Link>
            <Link href="/site/conteudos" className="hover:text-blue-600 transition-colors">Conteúdos</Link>
            <Link href="/site/sobre-nos" className="hover:text-blue-600 transition-colors">Sobre nós</Link>
          </div>

          <div className="flex items-center gap-4 text-sm font-bold shrink-0">
            <div className="hidden md:flex items-center gap-4">
              <a href={appLink} className="text-gray-800 hover:text-blue-600 transition-colors border-r border-gray-300 pr-4">Entrar</a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="bg-blue-600 text-white px-5 py-2.5 rounded-full hover:bg-blue-700 transition-all flex items-center gap-2 shadow-lg shadow-blue-600/20 whitespace-nowrap">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
            
            {/* Ícone Menu Mobile - Só aparece no celular (md:hidden) */}
            <button 
              className="md:hidden text-gray-800 p-2 transition-colors hover:text-blue-600"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Alternar menu"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* ================= MENU MOBILE (DROPDOWN) ================= */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-20 left-0 w-full bg-white shadow-xl border-t border-gray-100 flex flex-col p-6 gap-4 z-40 max-h-[calc(100vh-80px)] overflow-y-auto">
            <Link href="/site/solucoes" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Soluções <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/para-quem-e" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Para quem é <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/recursos" onClick={() => setIsMobileMenuOpen(false)} className="text-blue-600 font-bold py-3 border-b border-gray-50 flex justify-between items-center">
              Recursos <ChevronRight size={16} className="text-blue-400" />
            </Link>
            <Link href="/site/conteudos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Conteúdos <ChevronRight size={16} className="text-gray-400" />
            </Link>
            <Link href="/site/sobre-nos" onClick={() => setIsMobileMenuOpen(false)} className="text-gray-800 font-bold hover:text-blue-600 py-3 border-b border-gray-50 flex justify-between items-center">
              Sobre nós <ChevronRight size={16} className="text-gray-400" />
            </Link>
            
            <div className="flex flex-col gap-3 mt-4">
              <a href={appLink} className="w-full text-center text-gray-900 font-bold py-3.5 border-2 border-gray-200 rounded-full hover:bg-gray-50 transition-colors">
                Entrar no Sistema
              </a>
              <a href={wppLink} target="_blank" rel="noopener noreferrer" className="w-full bg-blue-600 text-white py-3.5 rounded-full font-bold hover:bg-blue-700 transition-all flex justify-center items-center gap-2 shadow-lg shadow-blue-600/20">
                Fale com um especialista <ArrowRight size={16} />
              </a>
            </div>
          </div>
        )}
      </nav>

      {/* ================= HERO SECTION ================= */}
      <section className="pt-40 pb-12 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <div className="text-blue-600 font-bold text-sm tracking-widest uppercase">Ecossistema Completo</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-[1.1] tracking-tight">
            Ferramentas pensadas para o seu <span className="text-blue-600">dia a dia.</span>
          </h1>
          <p className="text-lg text-gray-500 font-medium leading-relaxed max-w-2xl mx-auto">
            Descubra todos os recursos e módulos que compõem a melhor plataforma de gestão de SST do mercado.
          </p>
        </div>
      </section>

      {/* ================= SOLUÇÕES COMPLETAS (Idêntico à Home) ================= */}
      <section id="solucoes" className="py-24 bg-gray-50 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-16">
            <div className="max-w-2xl">
              <div className="text-blue-600 font-bold text-sm tracking-widest uppercase mb-4">Soluções Completas</div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 leading-tight tracking-tight">
                Funcionalidades que simplificam sua gestão e <span className="text-blue-600">protegem o que importa.</span>
              </h2>
            </div>
            <p className="text-base md:text-lg text-gray-500 font-medium max-w-md leading-relaxed pb-2">
              Tudo o que você precisa para uma gestão de SST eficiente, integrada e centrada nas pessoas.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            
            <div style={{ borderRadius: '24px' }} className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group">
              <div className="flex flex-row items-center gap-4 mb-5">
                <div style={{ borderRadius: '16px' }} className="w-14 h-14 bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">
                  <Brain size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 leading-tight">Psicossocial<br/>+ Plano</h3>
              </div>
              <p className="text-sm text-gray-500 font-medium mb-6">Avalie fatores psicossociais, identifique riscos e crie planos.</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Questionários</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Análise de riscos</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Relatórios</li>
              </ul>
            </div>

            <div style={{ borderRadius: '24px' }} className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group">
              <div className="flex flex-row items-center gap-4 mb-5">
                <div style={{ borderRadius: '16px' }} className="w-14 h-14 bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">
                  <Megaphone size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 leading-tight">Canal de<br/>Denúncia</h3>
              </div>
              <p className="text-sm text-gray-500 font-medium mb-6">Receba, acompanhe e trate denúncias com segurança e sigilo.</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Anonimato garantido</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Fluxos personalizados</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Em tempo real</li>
              </ul>
            </div>

            <div style={{ borderRadius: '24px' }} className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group">
              <div className="flex flex-row items-center gap-4 mb-5">
                <div style={{ borderRadius: '16px' }} className="w-14 h-14 bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
                  <ClipboardCheck size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 leading-tight">Checklist de<br/>Processos</h3>
              </div>
              <p className="text-sm text-gray-500 font-medium mb-6">Padronize rotinas, garanta conformidade e reduza falhas.</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Editáveis</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Web e mobile</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Evidências e fotos</li>
              </ul>
            </div>

            <div style={{ borderRadius: '24px' }} className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group">
              <div className="flex flex-row items-center gap-4 mb-5">
                <div style={{ borderRadius: '16px' }} className="w-14 h-14 bg-green-50 text-green-500 flex items-center justify-center shrink-0">
                  <Target size={28} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 leading-tight">Plano de<br/>Ação</h3>
              </div>
              <p className="text-sm text-gray-500 font-medium mb-6">Acompanhe medidas, prazos e responsáveis no sistema.</p>
              <ul className="space-y-3 mb-8 flex-1">
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-green-500 shrink-0 mt-0.5" /> Atribuições</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-green-500 shrink-0 mt-0.5" /> Notificações</li>
                <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-green-500 shrink-0 mt-0.5" /> Progresso geral</li>
              </ul>
            </div>

            {/* Linha Inferior */}
            <div className="sm:col-span-2 lg:col-span-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <div style={{ borderRadius: '24px' }} className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group">
                <div className="flex flex-row items-center gap-4 mb-5">
                  <div style={{ borderRadius: '16px' }} className="w-14 h-14 bg-orange-50 text-orange-500 flex items-center justify-center shrink-0">
                    <Shirt size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 leading-tight">Entrega EPI<br/>Automatizado</h3>
                </div>
                <p className="text-sm text-gray-500 font-medium mb-6">Controle entregas e validade de EPI automatically.</p>
                <ul className="space-y-3 mb-8 flex-1">
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-orange-500 shrink-0 mt-0.5" /> Estoque e CA</li>
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-orange-500 shrink-0 mt-0.5" /> Assinaturas digitais</li>
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-orange-500 shrink-0 mt-0.5" /> Treinamentos</li>
                </ul>
              </div>

              <div style={{ borderRadius: '24px' }} className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group">
                <div className="flex flex-row items-center gap-4 mb-5">
                  <div style={{ borderRadius: '16px' }} className="w-14 h-14 bg-blue-50 text-blue-600 flex items-center justify-center shrink-0">
                    <HelpCircle size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 leading-tight">Questionários<br/>Inteligentes</h3>
                </div>
                <p className="text-sm text-gray-500 font-medium mb-6">Aplique e analise questionários com resultados em tempo real.</p>
                <ul className="space-y-3 mb-8 flex-1">
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Modelos editáveis</li>
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Online/Offline</li>
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Relatórios gerados</li>
                </ul>
              </div>

              <div style={{ borderRadius: '24px' }} className="bg-white p-8 border border-gray-100 shadow-sm hover:shadow-lg transition-all flex flex-col h-full group">
                <div className="flex flex-row items-center gap-4 mb-5">
                  <div style={{ borderRadius: '16px' }} className="w-14 h-14 bg-purple-50 text-purple-600 flex items-center justify-center shrink-0">
                    <Users size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 leading-tight">Processo de<br/>CIPA Online</h3>
                </div>
                <p className="text-sm text-gray-500 font-medium mb-6">Organize eleições, atas e atividades da CIPA com facilidade.</p>
                <ul className="space-y-3 mb-8 flex-1">
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Eleições completas</li>
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Calendário legal</li>
                  <li className="flex items-start gap-2 text-sm text-gray-700 font-medium"><CheckCircle2 size={18} className="text-blue-600 shrink-0 mt-0.5" /> Atas e documentos</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ================= BENEFÍCIOS (Idêntico à Home) ================= */}
      <section className="py-20 px-6 bg-white">
        <div style={{ backgroundColor: '#050B14', borderRadius: '40px' }} className="max-w-7xl mx-auto flex flex-col md:flex-row relative shadow-2xl overflow-hidden p-8 md:p-12 lg:p-16 gap-8 md:gap-12 items-center">
          
          <div className="w-full md:w-[45%] flex justify-center relative z-10">
            <div style={{
              width: '100%', maxWidth: '420px', aspectRatio: '1 / 1',
              background: 'linear-gradient(135deg, #0ea5e9, #3b82f6, #10b981)', 
              clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)', 
              display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto'
            }}>
              <div style={{
                width: 'calc(100% - 12px)', height: 'calc(100% - 12px)',
                clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)',
                backgroundColor: '#050B14'
              }}>
                <img src="/beneficios.jpg" alt="Profissional de SST" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            </div>
          </div>

          <div className="w-full md:w-[55%] flex flex-col justify-center relative z-10">
            <div className="text-white font-bold text-sm tracking-widest uppercase mb-4">Benefícios</div>
            <h2 className="text-4xl lg:text-5xl font-black leading-tight tracking-tight mb-12 text-white">
              Mais eficiência, menos riscos, <br/>
              <span className="text-blue-500">mais resultados.</span>
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-10">
              <div>
                <div style={{ backgroundColor: 'rgba(30, 58, 138, 0.2)', borderColor: 'rgba(59, 130, 246, 0.3)', borderWidth: '1px', borderRadius: '16px' }} className="w-12 h-12 flex items-center justify-center text-blue-500 mb-5"><Check size={24} /></div>
                <h4 className="text-lg font-bold mb-2 text-white">Reduza riscos e evite multas</h4>
                <p style={{ color: '#9CA3AF' }} className="text-sm font-medium leading-relaxed">Esteja sempre em conformidade com a legislação.</p>
              </div>
              <div>
                <div style={{ backgroundColor: 'rgba(30, 58, 138, 0.2)', borderColor: 'rgba(59, 130, 246, 0.3)', borderWidth: '1px', borderRadius: '16px' }} className="w-12 h-12 flex items-center justify-center text-blue-500 mb-5"><Clock size={24} /></div>
                <h4 className="text-lg font-bold mb-2 text-white">Economize tempo e recursos</h4>
                <p style={{ color: '#9CA3AF' }} className="text-sm font-medium leading-relaxed">Automatize processos e elimine tarefas manuais.</p>
              </div>
              <div>
                <div style={{ backgroundColor: 'rgba(30, 58, 138, 0.2)', borderColor: 'rgba(59, 130, 246, 0.3)', borderWidth: '1px', borderRadius: '16px' }} className="w-12 h-12 flex items-center justify-center text-blue-500 mb-5"><User size={24} /></div>
                <h4 className="text-lg font-bold mb-2 text-white">Cuide do que importa</h4>
                <p style={{ color: '#9CA3AF' }} className="text-sm font-medium leading-relaxed">Mais segurança e bem-estar para os colaboradores.</p>
              </div>
              <div>
                <div style={{ backgroundColor: 'rgba(30, 58, 138, 0.2)', borderColor: 'rgba(59, 130, 246, 0.3)', borderWidth: '1px', borderRadius: '16px' }} className="w-12 h-12 flex items-center justify-center text-blue-500 mb-5"><BarChart2 size={24} /></div>
                <h4 className="text-lg font-bold mb-2 text-white">Tenha dados para decidir</h4>
                <p style={{ color: '#9CA3AF' }} className="text-sm font-medium leading-relaxed">Informações claras para decisões estratégicas.</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* ================= TECNOLOGIA E PERFORMANCE ================= */}
      <section className="py-24 bg-blue-50">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="text-blue-600 font-bold text-sm tracking-widest uppercase mb-4">Diferenciais Técnicos</div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 leading-tight tracking-tight mb-16">
            Construído com tecnologia de ponta
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-blue-100">
              <Cloud className="text-blue-500 mb-6" size={40}/>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Infraestrutura em Nuvem</h3>
              <p className="text-gray-500 text-sm leading-relaxed">Seus dados hospedados em servidores de alta disponibilidade. Acesse o NexusSafe a qualquer hora, de qualquer dispositivo, sem necessidade de instalação.</p>
            </div>
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-blue-100">
              <LockKeyhole className="text-blue-500 mb-6" size={40}/>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Segurança e Privacidade</h3>
              <p className="text-gray-500 text-sm leading-relaxed">Conformidade total com a LGPD. Utilizamos criptografia de ponta a ponta e controle granular de acessos para garantir que suas informações estejam blindadas.</p>
            </div>
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-blue-100">
              <Cpu className="text-blue-500 mb-6" size={40}/>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Alta Performance</h3>
              <p className="text-gray-500 text-sm leading-relaxed">Arquitetura moderna (Next.js e Node.js) desenhada para processar grandes volumes de dados sem lentidão, entregando relatórios instantâneos.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FOOTER ================= */}
      <footer style={{ backgroundColor: '#020617', paddingTop: '100px', paddingBottom: '40px' }} className="font-medium mt-auto">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-12 border-b border-gray-800 pb-16">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center mb-6">
              <Link href="/" className="flex items-center">
                <img src="/logo-nexus-branca.png" alt="NexusSafe" style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    const fallback = target.nextElementSibling as HTMLElement;
                    if(fallback) fallback.style.display = 'flex';
                  }}
                />
                <div style={{ display: 'none' }} className="items-center gap-2">
                  <ShieldCheck size={28} className="text-white" />
                  <span className="text-xl font-black text-white tracking-tight">NEXUSSAFE</span>
                </div>
              </Link>
            </div>
            <p style={{ color: '#9CA3AF' }} className="text-sm leading-relaxed mb-8">
              A plataforma inteligente que simplifica a gestão de Segurança e Saúde do Trabalho e conecta pessoas, dados e resultados.
            </p>
            <div className="flex gap-4">
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Linkedin size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Instagram size={18} /></a>
              <a href="#" style={{ backgroundColor: '#111827' }} className="w-10 h-10 rounded-full text-gray-400 flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors"><Youtube size={18} /></a>
            </div>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Soluções</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Psicossocial + Plano</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Canal de Denúncia</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Checklist</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Plano de Ação</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Entrega de EPI</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">Questionários</Link></li>
              <li><Link href="/site/solucoes" className="hover:text-white transition-colors">CIPA</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Para quem é</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Indústrias</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Construtoras</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Comércio</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Serviços</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Saúde</Link></li>
              <li><Link href="/site/para-quem-e" className="hover:text-white transition-colors">Educação</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Recursos</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-8">
              <li><Link href="/site/recursos" className="text-white transition-colors">Blog</Link></li>
              <li><Link href="/site/recursos" className="text-white transition-colors">Materiais</Link></li>
              <li><Link href="/site/recursos" className="text-white transition-colors">Webinars</Link></li>
              <li><Link href="/site/recursos" className="text-white transition-colors">Cases</Link></li>
            </ul>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Sobre Nós</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm">
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Institucional</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Parceiros</Link></li>
              <li><Link href="/site/sobre-nos" className="hover:text-white transition-colors">Contato</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5 uppercase">Fale Conosco</h4>
            <ul style={{ color: '#9CA3AF' }} className="space-y-3 text-sm mb-6">
              <li className="flex items-center gap-3"><Phone size={14} className="shrink-0"/> (48) 9.8879-6761</li>
              <li className="flex items-center gap-3"><Mail size={14} className="shrink-0"/> comercial@nexussafe.com.br</li>
            </ul>
            <a href={wppLink} target="_blank" rel="noopener noreferrer" className="inline-flex bg-blue-600 text-white px-5 py-2.5 rounded-full font-bold text-xs hover:bg-blue-700 transition-all items-center gap-2">
              Fale com um especialista <ArrowRight size={14} />
            </a>
          </div>
        </div>
        <div style={{ color: '#9CA3AF' }} className="max-w-7xl mx-auto px-6 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p className="text-center md:text-left">© 2026 NexusSafe - Criado por Leandro Rodrigo de Oliveira - Todos os direitos reservados</p>
          <div className="flex items-center gap-6">
            <a href="https://nexussafe.com.br/site/privacidade" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Política de Privacidade</a>
            <a href="https://nexussafe.com.br/site/termos" className="text-blue-500 hover:text-white transition-colors whitespace-nowrap">Termos de Uso</a>
          </div>
        </div>
      </footer>
    </div>
  );
}